import { useEffect, useState } from "react"

/**
 *Custom hook to manage the first-time user experience for Visual Search feature.
 * It checks localStorage to determine if the user is using the feature for the first time
 * and provides a state variable and setter function to manage this state.
 * @return {[boolean, React.Dispatch<React.SetStateAction<boolean>>]}
 */
export function useIsVSFeatFirstTime() {
  const [isFirstTime, setIsFirstTime] = useState(true)

  useEffect(() => {
    if (typeof window !== "undefined") {
      let isFirstTimeValue = localStorage.getItem("usingVSforFirstTime")
      if (isFirstTimeValue === null) {
        localStorage.setItem("usingVSforFirstTime", "true")
        isFirstTimeValue = "true"
      }
      setIsFirstTime(isFirstTimeValue === "true")
    }
  }, [])

  useEffect(() => {
    const handleStorageChange = event => {
      if (event.key === "usingVSforFirstTime") {
        setIsFirstTime(event.newValue === "true")
      }
    }

    window.addEventListener("storage", handleStorageChange)

    return () => {
      window.removeEventListener("storage", handleStorageChange)
    }
  }, [])
  return [isFirstTime, setIsFirstTime]
}
